import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center oaiMainContentFullScreen"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col gap-4 h-[calc(100vh-48px)] lg:h-screen"
}
const _hoisted_3 = { class: "md:px-6 px-4 flex-1 flex gap-2 lg:gap-4 items-center" }
const _hoisted_4 = { class: "truncate" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 text-base font-normal" }, "|", -1)
const _hoisted_6 = {
  key: 0,
  class: "flex gap-1 mr-4 min-w-0"
}
const _hoisted_7 = { class: "truncate" }

import { PlusIcon } from "@heroicons/vue/24/outline";
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import { useOrganizations } from "shared/composables/organization";
import { useHasPermission } from "shared/composables/project";
import { Organization } from "shared/types/Organization";
import PageHeader from "@/components/layout/PageHeader.vue";
import Sidebar from "@/components/layout/Sidebar.vue";
import AddOrganizationModal from "@/views/organizations/components/AddOrganizationModal.vue";
import OrganizationDetail from "@/views/organizations/components/OrganizationDetail.vue";
import OrganizationSelector from "@/views/organizations/components/OrganizationSelector.vue";
import OrganizationsViewMenu from "@/views/organizations/components/OrganizationsViewMenu.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationsView',
  setup(__props) {

const isAddOrganizationModalOpen = ref(false);

const route = useRoute();
const router = useRouter();
const { organizations, isLoading } = useOrganizations();

const hasAdminPermission = useHasPermission("app_admin");

const rootOrganizations = computed(() =>
  organizations.value.filter((organization) => !organization.parent_id),
);

const organizationsByParentId = computed(() =>
  organizations.value.reduce((acc, organization) => {
    if (!organization.parent_id) {
      return acc;
    }
    if (!acc[organization.parent_id]) {
      acc[organization.parent_id] = [];
    }
    (acc[organization.parent_id] as Organization[]).push(organization);
    return acc;
  }, {} as Record<string, Organization[] | undefined>),
);

const selectedOrganization = computed<Organization | undefined>(
  () =>
    organizations.value.find((organization) => organization._id === route.query.id) ||
    organizations.value.filter(
      (organization) => (organizationsByParentId.value[organization._id] || []).length === 0,
    )[0] ||
    organizations.value[0],
);

const selectOrganization = (organizationId: string | undefined) => {
  router.push({ query: { ...route.query, id: organizationId } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Sidebar, null, {
      default: _withCtx(() => [
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(LoadingSpinner)
            ]))
          : _createCommentVNode("", true),
        (!_unref(isLoading) && _unref(organizations))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(PageHeader, null, {
                content: _withCtx(() => [
                  (_unref(hasAdminPermission))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (isAddOrganizationModalOpen.value = true)),
                          type: "button",
                          class: "min-w-0 flex items-center gap-1 rounded bg-yellow-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-yellow-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
                        }, [
                          _createVNode(_unref(PlusIcon), { class: "h-5 w-5" }),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("organizations.add_organization")), 1)
                        ]),
                        _createVNode(OrganizationsViewMenu, { selectedOrganization: selectedOrganization.value }, null, 8, ["selectedOrganization"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("organizations.title")), 1),
                    _hoisted_5,
                    _createVNode(OrganizationSelector, {
                      rootOrganizations: rootOrganizations.value,
                      organizationsByParentId: organizationsByParentId.value,
                      selectedOrganization: selectedOrganization.value,
                      onSelectOrganization: selectOrganization
                    }, null, 8, ["rootOrganizations", "organizationsByParentId", "selectedOrganization"])
                  ])
                ]),
                _: 1
              }),
              (selectedOrganization.value)
                ? (_openBlock(), _createBlock(OrganizationDetail, {
                    key: selectedOrganization.value?._id,
                    organization: selectedOrganization.value,
                    organizationsByParentId: organizationsByParentId.value,
                    class: "lg:border-t flex-1 overflow-auto mt-4 lg:mt-0"
                  }, null, 8, ["organization", "organizationsByParentId"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (isAddOrganizationModalOpen.value)
      ? (_openBlock(), _createBlock(AddOrganizationModal, {
          key: 0,
          organization: selectedOrganization.value,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (isAddOrganizationModalOpen.value = false)),
          onSelectOrganization: selectOrganization
        }, null, 8, ["organization"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})